import { VipType } from '@tencent/ark-service-interface';
import { IAvatarProps } from '@tencent/dui/lib/components/Avatar/interface';
import { ReactNode } from 'react';

export { VipType };

export type AvatarNickNameplateOptions = {
    container?: HTMLDivElement; // 组件的容器
    avatarProps?: IAvatarProps; // 头像组件的参数，同dui Avatar组件参数，不传则不展示头像
    nickNameProps?: NicknameProps; // 昵称接收的参数，控制昵称的内容及样式
    nameplateProps?: NameplateProps; // vip铭牌接收的参数，控制铭牌的类型及样式
    avatarAlignment?: AvatarAlignment; // 头像的位置，支持头像在上方或左侧排列
    nickNameBottom?: ReactNode | HTMLElement; // 昵称下方的内容，支持传入完整的节点元素
};

export interface IStyleProps {
    className?: string;
    style?: React.CSSProperties;
}

// nickname有默认的样式，style可以不传。如果需要覆盖默认样式，可以通过style或className覆盖
export interface NicknameProps extends IStyleProps {
    nick?: string; // 昵称
    showVIPColor?: boolean; // 是否展示内置的昵称vip颜色
    maxWidth?: string; // 昵称最大宽度
}

// nameplate有默认的样式，style可以不传。如果需要覆盖默认样式，可以通过style或className覆盖
export interface NameplateProps extends IStyleProps {
    vipType?: VipType; // vipType如果不传，则不展示铭牌
    size?: NameplateSize;
    entry?: string; // 入口，上报用
}

export enum NameplateSize {
    MEDIUM = 'medium', // 铭牌高度为12
    BIG = 'big', // 铭牌高度为16
}

// 同dc组件中定义的VipTabType
export enum VipTabType {
    /** 不限制充值入口 */
    ANY_VIP = 0,
    /** 只展示超级会员充值入口 */
    JUST_SUPER_VIP = 1,
    /** 只展示普通会员充值入口 */
    JUST_NORMAL_VIP = 2,
}

// 头像的位置
export enum AvatarAlignment {
    TOP = 'top', // 头像在昵称和铭牌的上方
    LEFT = 'left', // 头像在昵称和铭牌的左侧，默认为left
}
